<template>
  <div class="edit-project-container">
    <div class="header">
      Editando proyecto
    </div>
    <div class="card">
      <div class="row">
        <div class="column-first">
          Información basica
        </div>
        <div class="column-second">
          <div class="label">
            <div class="label-text">Nombre</div>
            <BaseInput v-model="data.name" />
          </div>
          <div class="label">
            <div class="label-text">Ubicación</div>
            <BaseInput v-model="data.location" />
          </div>
          <div class="label label--half">
            <div class="label-text">Recaudación mín. (centavos)</div>
            <BaseInput v-model="data.minTarget" />
          </div>
          <div class="label label--half">
            <div class="label-text">Recaudación máx.(centavos)</div>
            <BaseInput v-model="data.maxTarget" />
          </div>
          <div class="label label--half">
            <div class="label-text">Recaudación actual (centavos)</div>
            <BaseInput v-model="data.raised" />
          </div>
          <div class="label label--half">
            <div class="label-text">Socios</div>
            <BaseInput v-model="data.backers" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">
          Retorno anual esperado
        </div>
        <div class="column-second">
          <div class="label label--third">
            <div class="label-text">Pesimista (%)</div>
            <BaseInput v-model="data.pessimistIrr" />
          </div>
          <div class="label label--third">
            <div class="label-text">Conservador (%)</div>
            <BaseInput v-model="data.conservativeIrr" />
          </div>
          <div class="label label--third">
            <div class="label-text">Optimista (%)</div>
            <BaseInput v-model="data.optimisticIrr" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">
          Pagos
        </div>
        <div class="column-second">
          <div class="label label--half">
            <div class="label-text">Número de pagos</div>
            <BaseInput v-model="data.totalMonthPayments" />
          </div>
          <div class="label label--half">
            <div class="label-text">Porcentaje de ventas (%)</div>
            <BaseInput v-model="data.salesPercentage" />
          </div>
          <div class="label">
            <div class="label-text">Inicio de pagos</div>
            <datepicker
              v-model="data.paymentsStartDate"
              initial-view="day"
              input-class="form-input"
              :full-month-name="true"
              :language="es" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">
          Estado
        </div>
        <div class="column-second">
          <div class="label">
            <BaseRadio :options="statusOptions" v-model="data.status" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">
          Descripción
        </div>
        <div class="column-second">
          <div class="link" style="margin-bottom: 20px;" @click="$router.push(`/project/${project.id}/editor`)">
            <span class="mdi mdi-pencil"></span> Editar descripción
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">
          Imágenes
        </div>
        <div class="column-second">
          <div class="gallery">
            <div
              v-for="media in project.mediaGallery"
              :key="media.id"
              class="gallery-image">
              <div class="remove-image" @click="deleteMedia(media.id)">X</div>
              <img v-if="media.type === 'image'" :src="media.url">
              <img v-if="media.type === 'video'" src="/video.png">
            </div>
            <label class="gallery-image">
              <input type="file" @change="uploadImage($event)">
              <img style="width: 40%; margin: 0 auto;" src="https://www.freeiconspng.com/uploads/upload-icon-30.png">
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">Añadir video</div>
        <div class="column-second">
          <div class="label" style="display: flex; flex-wrap: wrap; justify-content: space-between">
            <div class="label-text" style="width: 100%;">URL del video</div>
            <BaseInput v-model="videoUrl" style="width: 70%" />
            <div class="button" style="width: 20%" @click="uploadVideo">Guardar</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">
          Brackets
        </div>
        <div class="column-second">
          <div class="link" style="margin-bottom: 20px;" @click="$router.push(`/admin/projects/${project.id}/brackets`)">
            <span class="mdi mdi-pencil"></span> Editar brackets
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column-first">Subir archivos</div>
        <div class="column-second">
          <div class="label" style="display: flex; flex-wrap: wrap; justify-content: space-between">
            <div class="label-text" style="width: 100%;">Nombre del archivo</div>
            <BaseInput v-model="fileName" style="width: 70%" />
            <label style="width: 20%">
              <div class="button" style="width: 100%">Subir</div>
              <input type="file" @change="uploadFile($event)">
            </label>
          </div>
          <div class="files">
            <div class="file" v-for="file in project.files" :key="file.id">
              <a :href="file.url">{{ file.fileName }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <div class="button" @click="updateProject">
          Guardar
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';

const { mapState, mapActions } = createNamespacedHelpers('admin');
export default {
  data() {
    return {
      data: {
        name: null,
        location: null,
        minTarget: null,
        maxTarget: null,
        raised: null,
        backers: null,
        optimisticIrr: null,
        conservativeIrr: null,
        pessimistIrr: null,
        mainImageUrl: null,
        backgroundImageUrl: null,
        paymentsStartDate: null,
        totalMonthPayments: null,
        salesPercentage: null,
        isPremium: null,
        status: null,
      },
      es,
      statusOptions: [
        { text: 'Próximamente', value: 'soon' },
        { text: 'En progreso', value: 'progress' },
        { text: 'Finalizada', value: 'finished' },
        { text: 'Generando', value: 'completed' },
      ],
      videoUrl: '',
      fileName: '',
    };
  },
  components: {
    BaseInput,
    BaseRadio,
    Datepicker,
  },
  methods: {
    async updateProject() {
      const { id } = this.$route.params;
      await this.editProject({
        id,
        data: this.data,
      });
      this.$router.push('/admin/projects');
    },
    async deleteMedia(id) {
      await this.removeMedia({
        projectId: this.$route.params.id,
        id,
      });
    },
    async uploadImage(event) {
      const fd = new FormData();
      const file = event.target.files[0];
      const url = `${process.env.VUE_APP_SERVER_URL}/public-upload`;
      fd.append('image', file);
      const response = await axios.post(url, fd);
      await this.createMedia({
        data: {
          url: response.data.src,
          type: 'image',
        },
        projectId: this.$route.params.id,
      });
    },
    async uploadVideo() {
      const youtubeBase = 'https://www.youtube.com/embed/';
      await this.createMedia({
        data: {
          url: youtubeBase + this.videoUrl.split('/').pop(),
          type: 'video',
        },
        projectId: this.$route.params.id,
      });
      this.videoUrl = '';
    },
    async uploadFile(event) {
      const fd = new FormData();
      const file = event.target.files[0];
      const url = `${process.env.VUE_APP_SERVER_URL}/public-upload`;
      fd.append('image', file);
      const response = await axios.post(url, fd);
      await this.createFile({
        projectId: parseInt(this.$route.params.id, 10),
        data: {
          fileName: this.fileName,
          url: response.data.src,
        },
      });
      this.fileName = '';
    },
    ...mapActions([
      'createMedia',
      'getProject',
      'editProject',
      'removeMedia',
      'createFile',
    ]),
  },
  computed: {
    ...mapState([
      'project',
      'users',
    ]),
  },
  async mounted() {
    const projectId = parseInt(this.$route.params.id, 10);
    await this.getProject(projectId);
    const keys = Object.keys(this.data);
    keys.forEach((key) => {
      this.data[key] = this.project[key];
    });
  },
};
</script>

<style lang="scss" scoped>
.edit-project-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.header {
  font-size: 28px;
  font-weight: bold;
  width: 100%;
}
.card {
  border: 1px solid #e8e8e8;
  background-color: white;
  padding: 30px;
  border-radius: 6px;
  margin-top: 24px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.row {
  display: flex;
  width: 100%;

  & + .row {
    margin-top: 10px;
  }
}
.column-first {
  width: 35%;
  font-weight: bold;
}
.column-second {
  width: 65%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.label {
  width: 100%;
  margin-bottom: 20px;
}
.label--half {
  width: 48%;
}
.label--third {
  width: 30%;
}
.label-text {
  line-height: 18px;
  margin-bottom: 12px;
}
/deep/ .form-input {
  font-size: 15px;
  border: none;
  border: 1px solid #e8e8e8;
  padding: 8px;
  font-family: inherit;
  width: 100%;
  border-radius: 4px;

  &:focus {
    border: 1px solid #3479e9;
  }
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 34px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 20px;
  display: flex;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
.link {
  color: #3479e9;
  border-bottom: 1px solid #3479e9;
  cursor: pointer;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
}
.gallery-image {
  background-color: #f6f6f6;
  // background-color: rgba(0, 0, 0, 0.8);
  width: 31%;
  height: auto;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-right: 2%;
  position: relative;

  img {
    width: 100%;
  }
}
.remove-image {
  color: red;
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: rgba(0, 0, 0, 0.596);
  font-size: 12px;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.files {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.file {
  margin-top: 10px;
  color: #3479e9;
}
@media only screen and (max-width: 740px) {
  .row {
    flex-direction: column;
  }
  .column-first {
    width: 100%;
    margin-bottom: 16px;
  }
  .column-second {
    width: 100%;
  }
}
@media only screen and (max-width: 550px) {
  .label--half {
    width: 100%;
  }
  .label--third {
    width: 48%;
  }
}
@media only screen and (max-width: 400px) {
  .label--third {
    width: 100%;
  }
}
</style>
